import React from 'react';
import { UnitPicker } from '../UnitPicker/UnitPicker';
export var UnitValueEditor = function (_a) {
    var value = _a.value, onChange = _a.onChange;
    return React.createElement(UnitPicker, { value: value, onChange: onChange });
};
//# sourceMappingURL=units.js.map